export default {
  getMyHomeProjectList: ({ projectList }) => {
    return projectList
  },
  getMyHomeWorkRequestList: ({ workRequestList }) => {
    return workRequestList
  },
  getMyHomeNoticeList: ({ noticeList }) => {
    return noticeList
  },
  getMyHomeQnaList: ({ qnaList }) => {
    return qnaList
  },
}



// WEBPACK FOOTER //
// ./src/vuex/home/myHomeGetter.js